import { me } from '../data/state.js';
import { effectiveGrouping } from './format.js';

/** Locale used by currency and number formatting. */
export function currencyLocale(): 'en-IN' | 'en-US' {
  const grouping = effectiveGrouping((me.value?.preferences ?? {}).numberGrouping, me.value?.orgNumberGrouping);
  return grouping === 'pakistani' ? 'en-IN' : 'en-US';
}

/**
 * Currency text for attributes and other places that cannot host a custom element. Keeps up to
 * four meaningful decimals unless `fractionDigits` asks for exactly that many.
 */
export function formatCurrencyText(value: number | null, currency: string, fractionDigits?: number): string {
  if (value === null || !Number.isFinite(value)) return '—';
  return new Intl.NumberFormat(currencyLocale(), {
    style: 'currency',
    currency,
    currencyDisplay: 'code',
    minimumFractionDigits: fractionDigits ?? 0,
    maximumFractionDigits: fractionDigits ?? 4,
  }).format(value);
}

/** Format a ratio as a user-visible percent. */
export function formatPercentText(
  value: number,
  options: { maximumFractionDigits?: number; signed?: boolean } = {},
): string {
  return new Intl.NumberFormat(currencyLocale(), {
    style: 'percent',
    maximumFractionDigits: options.maximumFractionDigits,
    signDisplay: options.signed === true ? 'exceptZero' : 'auto',
  }).format(value);
}
